import React, { useEffect, useState } from "react";
import {
  Table,
  Select,
  Input,
  DatePicker,
  Button,
  Row,
  Spin,
  Col,
  message,
} from "antd";
import styled from "styled-components";
import { SearchOutlined } from "@mui/icons-material";
import { ReactComponent as Suspend } from "../../assets/suspend.svg";
import { useHistory } from "react-router-dom";
import { CALL_API } from "common/API";
import { getClientid, getUserInfo } from "redux/selectors";
import { connect } from "react-redux";
import { ReactComponent as Info } from "../../assets/Frame 2147225144.svg";

import moment from "moment";

const CustomStyle = styled.div`
 .ant-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-size: 15.2px;
    font-weight: 400;
    color: #636980;
  }
  .searchbar {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .searchicon {
    color: #636980;
  }
  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  /* Hover effect to change color on hover */
  .dropdown-container a:hover {
    color: #1890ff;
  }
  .dropdown-container a .anticon {
    margin-left: 5px; /* Adjust spacing */
    font-size: 9px; /* Make the arrow smaller */
  }
  .totaldropdowns {
    display: flex;
    gap: 10px !important;
  }
  .adjust-margin {
    margin-top: 10px;
    margin-left: 3px;
  }
  .heading {
    font-size: 20px;
    font-weight: 500;
  }
  .clearance-text {
    color: #08c108;
  }
  .suspend-text {
    color: #2d53da;
    text-decoration: underline;
  }
  .date-range-container {
    display: flex;
    gap: 10px;
  }
  .datepicker-style {
    width: 180px;
    height: 34px;
    border-radius: 24px;
  }
  @media (max-width: 375px) {
    .totaldropdowns {
      display: block;
    }
    .searchbar {
      margin-bottom: 10px;
    }
    .dropdown-container {
      margin-bottom: 10px;
    }
  }
  @media (max-width: 768px) {
    .searchbar {
      margin-bottom: 10px;
    }
    .dropdown-container {
      margin-bottom: 10px;
    }
  }
`;

const HomeDisciplinary = ({ userInfo }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [filtered, setFilteredData] = useState([]);
  const [filteredData, setFilteredData1] = useState([]);
  const [actionValue, setActionValue] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const dataSource = [
    {
      key: "1",
      DiscipID: "DIS123456",
      date: "25th Aug 2024",
      Category: "Criminal Offense",
      Action: "First Warning",
      Movedto: "Clearance",
      Createdon: "25th Aug 2024",
      Createdby: "Alvin David",
    },
    {
      key: "2",
      DiscipID: "DIS123456",
      date: "25th Aug 2024",
      Category: "Criminal Offense",
      Action: "First Warning",
      Movedto: "Suspend",
      Createdon: "25th Aug 2024",
      Createdby: "Alvin David",
    },
    {
      key: "3",
      DiscipID: "DIS123456",
      date: "25th Aug 2024",
      Category: "Criminal Offense",
      Action: "First Warning",
      Movedto: "Clearance",
      Createdon: "25th Aug 2024",
      Createdby: "Alvin David",
    },
    {
      key: "4",
      DiscipID: "DIS123456",
      date: "25th Aug 2024",
      Category: "Criminal Offense",
      Action: "First Warning",
      Movedto: "Suspend",
      Createdon: "25th Aug 2024",
      Createdby: "Alvin David",
    },
  ];

  const [showLoader, toggleLoader] = useState(false);
  const [assetsData, setDisData] = useState([]);

  const getDisData = async () => {
    try {
      setLoading(true);

      // Make GET request
      const { data, code } = await CALL_API(
        `disciplinary/${userInfo.userid}`,
        "get",
        {}
      );

      if (code === "SUCCESS") {
        const reversedData = data.reverse();

        setDisData(reversedData);
      } else {
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      setLoading(false); // Hide loader after API call
    }
  };
  useEffect(() => {
    getDisData();
  }, []);
  const getColor = (action) => {
    if (!action) return "black";

    action = action.toLowerCase();
    return action.includes("suspend")
      ? "#2D53DA" // Blue
      : action.includes("first") || action.includes("second") || action.includes("verbal")
        ? "#119DE5"
        : action.includes("third") || action.includes("show cause")
          ? "#F28916"
          : action.includes("demotion")
            ? "#8E2A5E"
            : action.includes("exoneration") || action.includes("clearance")
              ? "#22AD22"
              : action.includes("termination")
                ? "#D90325"
                : " #636980";
  };
  const columns = [
    {
      title: "Discip. ID ",
      dataIndex: "disciplinaryId",

      key: "disciplinaryId",
    },
    {
      title: "Date of Incident",
      dataIndex: "dateofincident",
      width: "250px",
      key: "dateofincident",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Action",
      dataIndex: "actions",
      key: "actions",
      // render: (text, record) => {
      //   let displayStatus = text;

      //   // If the action is "Commented" or "Update the ticket", try to find the previous action
      //   if ((text === "Commented" || text === "Update the ticket") && record?.actiontimeline?.length > 0) {
      //     let foundPreviousStatus = false;

      //     // Loop through the action timeline in reverse order
      //     for (let i = record.actiontimeline.length - 1; i >= 0; i--) {
      //       // Check if the actionmoveon is not "Commented" or "Update the ticket"
      //       if (record.actiontimeline[i].actionmoveon !== "Commented" && record.actiontimeline[i].actionmoveon !== "Update the ticket") {
      //         displayStatus = record.actiontimeline[i].actionmoveon;
      //         foundPreviousStatus = true;
      //         break;
      //       }
      //     }

      //     // If no previous status is found, retain the original "Commented" or "Update the ticket" value
      //     if (!foundPreviousStatus) {
      //       displayStatus = text; // Or you can set a fallback value if needed
      //     }
      //   }

      //   return displayStatus;
      // }
    },
    {
      title: "Moved to",
      dataIndex: "actiontimeline",

      key: "actionmoveon",
      render: (actiontimeline) => {
        let lastAction = "-";
        if (actiontimeline && actiontimeline.length > 0) {
          for (let i = actiontimeline.length - 1; i >= 0; i--) {
            const action = actiontimeline[i]?.actionmoveon;
            if (
              action &&
              action !== "Commented" &&
              action !== "Update the ticket"
            ) {
              lastAction = action;
              break;
            }
          }
        }

        return (
          <span
            style={{
              color: getColor(lastAction),
              display: "flex",
              alignItems: "center",
              gap: "5px", // Adds space between text & icon
            }}
          >
            {lastAction}
            {lastAction.toLowerCase() === "suspend" && <Info style={{ color: "#119DE5" }} />}
          </span>
        );
      },
    },
    {
      title: "Created on",
      dataIndex: "insertedAt",
      key: "insertedAt",
      width: "250px",
      render: (text) =>
        text && moment(text, "YYYY-MM-DD").isValid()
          ? moment(text, "YYYY-MM-DD").format("Do MMMM YYYY")
          : "-",
    },
    {
      title: "Created by",
      dataIndex: "createdByUserName",
      key: "createdByUserName",
    },
  ];
  const [showDateRange, setShowDateRange] = useState(false); // State to track custom date range selection
  useEffect(() => {
    let filtered = assetsData;
    if (searchText) {
      filtered = filtered.filter((disciplinary) =>
        disciplinary?.employee?.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    if (selectedType) {
      filtered = filtered.filter(
        (disciplinary) =>
          disciplinary?.category?.trim().toLowerCase() ===
          selectedType.toLowerCase()
      );
    }
    if (actionValue) {
      filtered = filtered.filter((disciplinary) =>
        disciplinary?.actions
          ?.trim()
          .toLowerCase()
          .includes(actionValue.toLowerCase())
      );
    }
    let startDate, endDate;
    if (selectedDateRange === "Last week") {
      startDate = moment().subtract(1, "weeks").startOf("week");
      endDate = moment().subtract(1, "weeks").endOf("week");
    } else if (selectedDateRange === "Last month") {
      startDate = moment().subtract(1, "months").startOf("month");
      endDate = moment().subtract(1, "months").endOf("month");
    } else if (selectedDateRange === "Last 6 months") {
      startDate = moment().subtract(6, "months").startOf("month");
      endDate = moment().endOf("month");
    } else if (selectedDateRange === "Custom Date range") {
      startDate = moment(fromDate).startOf("day");
      endDate = moment(toDate).endOf("day");
    }
    if (
      startDate &&
      endDate &&
      !isNaN(new Date(startDate).getTime()) &&
      !isNaN(new Date(endDate).getTime())
    ) {
      filtered = filtered.filter((disciplinary) =>
        moment(disciplinary.dateofincident).isBetween(
          startDate,
          endDate,
          null,
          "[]"
        )
      );
    }

    setFilteredData1(filtered);
  }, [
    searchText,
    selectedType,
    assetsData,
    actionValue,
    selectedDateRange,
    fromDate,
    toDate,
  ]);
  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "Custom Date range") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };
  return (
    <CustomStyle>
      <div className="heading">
        <p>Disciplinary Management</p>
      </div>
      <div className="totaldropdowns">
        <Row gutter={16}>
          <Col>
            <div>
              <Input
                className="searchbar"
                placeholder="Search Name"
                prefix={<SearchOutlined className="searchicon" />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select
                placeholder="Category"
                className="action-dropdown"
                onChange={(value) => setSelectedType(value)}
                allowClear
              >
                <Select.Option value="Absence from duty without permission">
                  Absence from duty without permission
                </Select.Option>
                <Select.Option value="Unwillingness and inability to perform duties">
                  Unwillingness and inability to perform duties
                </Select.Option>
                <Select.Option value="Damage to Company property">
                  Damage to Company property
                </Select.Option>
                <Select.Option value="Loss of Company property">
                  Loss of Company property
                </Select.Option>
                <Select.Option value="Unauthorized possession of Company property">
                  Unauthorized possession of Company property
                </Select.Option>
                <Select.Option value="Insubordination">
                  Insubordination
                </Select.Option>
                <Select.Option value="Use of abusive language, harassment, or bullying">
                  Use of abusive language, harassment, or bullying
                </Select.Option>
                <Select.Option value="Gross negligence">
                  Gross negligence
                </Select.Option>
                <Select.Option value="Wilful damage to or theft of company property">
                  Wilful damage to or theft of company property
                </Select.Option>
                <Select.Option value="Fraud or dishonesty in dealing with the company">
                  Fraud or dishonesty in dealing with the company
                </Select.Option>
                <Select.Option value="Theft or misappropriation of Company funds">
                  Theft or misappropriation of Company funds
                </Select.Option>
                <Select.Option value="Under drugs or alcohol during working hours">
                  Under drugs or alcohol during working hours
                </Select.Option>
                <Select.Option value="Noncompliance to standard operating procedure">
                  Noncompliance to standard operating procedure
                </Select.Option>
              </Select>
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select
                placeholder="Date"
                className="action-dropdown"
                onChange={handleSelectChange}
                allowClear
              >
                <Select.Option value="Last week">Last week</Select.Option>
                <Select.Option value="Last month">Last month</Select.Option>
                <Select.Option value="Last 6 months">
                  Last 6 months
                </Select.Option>
                <Select.Option value="Custom Date range">
                  Custom Date range
                </Select.Option>
              </Select>
            </div>
          </Col>
          {showDateRange && ( // Conditionally render the date pickers
            <div className="date-range-container">
              <Col>
                <div>
                  <DatePicker
                    placeholder="From"
                    format="DD-MM-YYYY"
                    className="datepicker-style"
                    onChange={(dateofincident) => {
                      setFromDate(dateofincident);
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div>
                  <DatePicker
                    placeholder="To"
                    format="DD-MM-YYYY"
                    className="datepicker-style"
                    onChange={(dateofincident) => setToDate(dateofincident)}
                  />
                </div>
              </Col>
            </div>
          )}
          <Col
            className={`dropdown-container ${showDateRange ? "adjust-margin" : ""
              }`}
          >
            <div className="dropdown-container">
              <Select
                placeholder="Action"
                className="action-dropdown"
                onChange={(value) => setActionValue(value)}
                allowClear
              >
                <Select.Option value="Verbal Warning">
                  Verbal Warning
                </Select.Option>
                <Select.Option value="First Warning">
                  First Warning
                </Select.Option>
                <Select.Option value="Second Warning">
                  Second Warning
                </Select.Option>
                <Select.Option value="Third & Final Warning">
                  Third & Final Warning
                </Select.Option>
                <Select.Option value="Show Cause">Show Cause</Select.Option>
                <Select.Option value="Suspend">Suspend</Select.Option>
                <Select.Option value="Demotion">Demotion</Select.Option>
                <Select.Option value="exoneration">Exoneration</Select.Option>
                <Select.Option value="Clearance">Clearance</Select.Option>
                <Select.Option value="Termination">Termination</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      {/* Table */}
      <Spin spinning={loading} size="medium">
        <Table
          dataSource={filteredData || []}
          columns={columns}
          pagination={true}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push(`/viewdisciplinary/${record.disciplinaryId}`, {
                  record: record,
                });
              },
            };
          }}
          scroll={{ x: "max-content" }}
          style={{ cursor: "pointer" }}
        />
      </Spin>
    </CustomStyle>
  );
};
const mapStateToProps = (state) => ({
  clientId: getClientid(state),
  userInfo: getUserInfo(state),
});
export default connect(mapStateToProps)(HomeDisciplinary);
